module.exports = __webpack_public_path__ + "static/media/fbe-icon-gold.7fea380b.svg";